import React from 'react'
import { CardMedia, Typography } from '@mui/material';


const Home = ({width}) => {

    return ( 
        <div className='color-text mr-0 row'>
            <div className='col-md-7 text-center pr-0' data-aos="fade-right" style={{marginTop: '10%'}}>
                <Typography variant='h4' className='border-bottom border-primary pb-5'>
                    ประสบการณ์ใหม่บน My GPF Application
                </Typography>
                <Typography variant={width > 800 ? 'h2' : 'h4'} className='mt-5 text-lighting'>
                    <b>เมนู My GPF & My GPF Twins</b>
                </Typography>
                <Typography className='mt-5 mb-3 text-lighting' variant={width > 800 ? 'h4' : 'h6'}>
                    "รู้ ลอง เลือก เพื่อเกษียณที่ดีกว่า"
                </Typography>
                <Typography variant={width > 800 ? 'h4' : 'h6'} className='text-lighting'>
                    <i>I Choose , My Choices</i>
                </Typography>
            </div>
            <div className='col-md' data-aos="fade-up">
                <img src='https://gpfimg-cdn.azureedge.net/micrositemygpftwins/Asset1.webp' width='100%'/>
            </div>
        </div>
     );
}
 
export default Home;